// extracted by mini-css-extract-plugin
export default {"table":"KitchenPrinterList_table__WgVvi","badge":"KitchenPrinterList_badge__4rRfi","btn":"KitchenPrinterList_btn__qq2Uu"};